import type { SeriesSpec } from "../types/multi-time-series";

const MODE_TO_TAG: Record<SeriesSpec["mode"], string> = {
  CURRENT: "CURRENT_MULTITIME_PLOT_MODE",
  RELATIVE: "RELATIVE",
  HISTORICAL: "HISTORICAL",
};

/**
 * Inverse of MODE_TO_TAG. Used by the multi-time prepop path to translate the
 * `multitime_mode` URL string (which the Rust backend emits verbatim from the
 * Mviews.ini file) back into the canonical `MultiTimeMode` enum. The match is
 * case-insensitive, mirroring the C++ (single_tiger_view.cpp lowercases and
 * matches "historical"/"relative"; anything else is CURRENT). "ABSOLUTE" is
 * this port's legacy name for HISTORICAL, kept for saved tool sets.
 */
export function parseMultiTimeMode(s: string | undefined): SeriesSpec["mode"] {
  const upper = (s ?? "").toUpperCase();
  if (upper === "RELATIVE") return "RELATIVE";
  if (upper === "HISTORICAL" || upper === "ABSOLUTE") return "HISTORICAL";
  return "CURRENT";
}

export function buildMultiTimeGraphParams(series: SeriesSpec[]): string {
  const parts: string[] = [
    "graph_type=5",
    "session_type=HIST",
    `number_of_plots=${series.length}`,
  ];
  series.forEach((s, i) => {
    parts.push(`plot[${i}].tag_name=${s.tagName}`);
    parts.push(`plot[${i}].colour=${s.colour}`);
    parts.push(`plot[${i}].multitime_mode=${MODE_TO_TAG[s.mode]}`);
    parts.push(`plot[${i}].multitime_model_event=${s.eventModel}`);
    parts.push(`plot[${i}].multitime_relative_index=${s.relativeIndex}`);
    parts.push(`plot[${i}].multitime_start_time=${s.startTime}`);
    parts.push(`plot[${i}].multitime_end_time=${s.endTime}`);
    parts.push(`plot[${i}].turbine_state=${s.turbineState || "DEFAULT"}`);
  });
  return parts.join("|");
}
